// extracted by mini-css-extract-plugin
export var container = "styles-module__container___sKyxd";
export var title = "styles-module__title___bdvYi";
export var actionHeader = "styles-module__actionHeader___NCwL9";
export var scrollable = "styles-module__scrollable___OOrf6";
export var section = "styles-module__section___byUX1";
export var ctaFooter = "styles-module__ctaFooter___O58kR";
export var button = "styles-module__button___H5PC6";